var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "user-card",
      class: {
        "bg-purple-lightest border-color-purple-light":
          _setup.userInfo.isImpersonated,
      },
    },
    [
      _c(_setup.CFileInput, {
        staticClass: "picture-input",
        attrs: {
          value: [],
          accept: ".png,.jpg,.jpeg",
          "display-preview": false,
          disabled: !_setup.canUploadPicture || _setup.isUploading,
        },
        on: { input: _setup.onPictureSelected },
        scopedSlots: _vm._u([
          {
            key: "uploadTrigger",
            fn: function ({ onFileUpload, disabled }) {
              return [
                _c(
                  _setup.CUserAvatar,
                  {
                    staticClass: "avatar",
                    class: { uploadable: !disabled },
                    attrs: {
                      name: _setup.userInfo.fullName,
                      "picture-path": _setup.userInfo.picturePath,
                      size: 42,
                    },
                    nativeOn: {
                      click: function ($event) {
                        disabled ? undefined : onFileUpload()
                      },
                    },
                  },
                  [
                    _setup.userInfo.isImpersonated
                      ? _c(_setup.CUserAvatar, {
                          staticClass: "impersonate-avatar",
                          attrs: {
                            circle: "",
                            name: _setup.userInfo.impersonatedName,
                            "picture-path":
                              _setup.userInfo.impersonatedPicturePath,
                            size: 20,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _setup.isUploading
                      ? _c(
                          "div",
                          { staticClass: "picture-overlay" },
                          [
                            _c("font-awesome-icon", {
                              staticClass: "fa-spin",
                              attrs: { icon: ["fas", "spinner-third"] },
                            }),
                          ],
                          1
                        )
                      : !disabled
                      ? _c(
                          "div",
                          { staticClass: "picture-overlay hover-only" },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: ["fas", "arrow-up-from-bracket"] },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      !_vm.collapsed
        ? [
            _c("div", { staticClass: "user-info mr-2" }, [
              _c("span", { staticClass: "font-weight-bold" }, [
                _vm._v(_vm._s(_setup.userInfo.fullName)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "text-truncate" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_setup.userInfo.username) +
                    "\n            "
                ),
              ]),
            ]),
            _vm._v(" "),
            _setup.isImpersonateEnabled
              ? _c(_setup.CButton, {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: "Impersonate", boundary: "window" },
                      expression:
                        "{ content: 'Impersonate', boundary: 'window' }",
                    },
                  ],
                  staticClass: "ml-auto color-purple",
                  attrs: {
                    size: "icon",
                    icon: ["fas", "face-disguise"],
                    disabled: !_vm.hasAccountsToImpersonate,
                  },
                  on: {
                    click: function ($event) {
                      return _setup.emit("impersonate")
                    },
                  },
                })
              : _setup.isSwitchTeamEnabled
              ? _c(_setup.CButton, {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: "Switch Team", boundary: "window" },
                      expression:
                        "{ content: 'Switch Team', boundary: 'window' }",
                    },
                  ],
                  attrs: {
                    size: "icon",
                    icon: ["fas", "arrow-left-arrow-right"],
                  },
                  on: {
                    click: function ($event) {
                      return _setup.emit("impersonate-child")
                    },
                  },
                })
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }